// eslint-disable-next-line import/no-extraneous-dependencies
import reactCSS from 'reactcss';
import React from 'react';
import { UNIT } from '../../constants/theme';

const hex2rgba = (hex, alpha = 1) => {
  if (hex && hex !== '' && hex.match(/\w\w/g) !== null) {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  }
};

function Swatch ({ color, secondaryColor, onClick }) {
  const styles = reactCSS({
    default: {
      color: {
        width: UNIT * 1.89875,
        height: UNIT * 1.89875,
        borderRadius: UNIT * 1.25,
        background: color
          ? `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`
          : hex2rgba(secondaryColor)
      },
      swatch: {
        padding: UNIT * 0.1875,
        background: '#fff',
        borderRadius: UNIT * 1.25,
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer'
      }
    }
  });
  return (
    <div style={styles.swatch} onClick={onClick}>
      <div style={styles.color} />
    </div>
  );
  
}

export default (Swatch);
